import React, {Fragment} from "react";
import logoGorgias from "../../../../../images/logos/logo_gorgias.svg";
import {useSelector} from "react-redux";
import ChannelCard from "../../Utilities/ChannelCard";
import GorgiasSetupModal from "./GorgiasSetupModal";
import DataSourceWebhookModal from "../../Utilities/DataSourceWebhookModal";
import useGorgiasSetup from "./useGorgiasSetup";

export default function GorgiasProvider(){
    const gorgias = useSelector((state) => state.gorgiasAuth)
    const { initiateGorgiasSetup, gorgiasSetupOpen, handleGorgiasSetupOpen, handleGorgiasSetupClose } = useGorgiasSetup()

    return(
        <Fragment>
            <ChannelCard
                icon={logoGorgias}
                label={'Gorgias'}
                description={'Send personalized winback messages or resolve support tickets'}
                onClick={initiateGorgiasSetup}
            />
            <GorgiasSetupModal
                open={gorgiasSetupOpen}
                handleOpen={handleGorgiasSetupOpen}
                handleClose={handleGorgiasSetupClose}
            />
            <DataSourceWebhookModal
                showWebhookUrl={gorgias?.showWebhookUrl}
                webhookUrl={gorgias?.data?.webhookUrl}
                platformUrl={gorgias?.data?.platformUrl}
                dataSourceName={'Gorgias'}
            />
        </Fragment>
    )
}